import { Sprout } from "lucide-react";

const ITEMS = [
  "Finger Turmeric",
  "Red Chillies — All Grades",
  "Groundnut Oil",
  "Sunflower Oil",
  "Sesame Oil",
  "Flaxseed Oil",
  "Extra Virgin Olive Oil",
  "AGMARK Grade Sourcing",
];

const Row = ({ hidden }) => (
  <div className="flex shrink-0 items-center" aria-hidden={hidden}>
    {ITEMS.map((item) => (
      <span key={`${item}-${hidden}`} className="flex items-center">
        <span className="px-6 font-serif text-lg italic tracking-wide text-cream/90 sm:text-xl">{item}</span>
        <Sprout size={15} className="shrink-0 text-amberwarm" />
      </span>
    ))}
  </div>
);

export default function Marquee() {
  return (
    <div data-testid="commodities-marquee" className="overflow-hidden border-y border-night/10 bg-botanical py-4">
      <div className="animate-marquee flex w-max">
        <Row hidden={false} />
        <Row hidden={true} />
      </div>
    </div>
  );
}
